import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setAmountError } from '../../features/createBudget/createBudgetSlice';
import {
  formatAmountForInput,
  isInvalidAmount,
  sanitizeAmountInput,
} from '../../helpers/budgetValidation';
import Input from '../reusable/Input/Input';
import ErrorField from './ErrorField';
import LabelField from './LabelField';

const BudgetAmountInput = ({ error, value, onChange }) => {
  const dispatch = useDispatch();

  const handleClearAmountError = useCallback(() => {
    dispatch(setAmountError(''));
  }, [dispatch]);

  const handleChange = useCallback(
    e => {
      handleClearAmountError();
      const sanitized = sanitizeAmountInput(e.target.value);
      if (isInvalidAmount(sanitized)) return;
      onChange(sanitized);
    },
    [onChange, handleClearAmountError],
  );

  return (
    <>
      <LabelField>Budget Amount</LabelField>
      <Input
        name="amount"
        value={formatAmountForInput(value)}
        styled="mb"
        placeholder="Enter Your Budget Amount"
        onChange={handleChange}
      />
      {error && <ErrorField>{error}</ErrorField>}
    </>
  );
};

export default BudgetAmountInput;
